import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SpeedDial, SpeedDialAction, Badge } from '@mui/material';
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';

const ActionsDial = function ActionsDial({ actions, badgeNumber = 0 }) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <SpeedDial
      sx={{
        position: 'absolute',
        bottom: 10,
        right: 16,
      }}
      ariaLabel={intl.messages.CUSTOMER_ACTIONS}
      icon={
        <Badge
          color="error"
          badgeContent={badgeNumber}
          invisible={!badgeNumber}
        >
          <CreateRoundedIcon />
        </Badge>
      }
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions?.map(({ icon, name, onClick, badgeContent, disabled }) => (
        <SpeedDialAction
          key={name}
          icon={
            <Badge
              color="error"
              badgeContent={badgeContent}
              invisible={!badgeContent}
            >
              {icon}
            </Badge>
          }
          tooltipTitle={name}
          onClick={onClick}
          FabProps={{
            disabled,
          }}
        />
      ))}
    </SpeedDial>
  );
};

ActionsDial.propTypes = {
  actions: PropTypes.array.isRequired,
  badgeNumber: PropTypes.number,
};

export default ActionsDial;
